import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-landeskennzeichen-list-view',
  imports: [],
  templateUrl: './landeskennzeichen.list-view.html',
  styleUrls: ['./landeskennzeichen.list-view.css'],
})
export class LandeskennzeichenListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
